import { EmailTemplateOverviewComponent } from './pages/email-template-overview/email-template-overview.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';

import { LogoutPage } from './pages/logout/logout.page';
import { LandingPage } from './pages/grid-connection-list/landing/landing.page';

import { AppLoginComponent } from './components/app-login/app-login.component';

import { TemplatesPageComponent } from './pages/templates/templates.page';

import { ContactsComponent } from './pages/contacts/contacts.page';
import { ConfigPageComponent } from './pages/config/config.page';
import { ConfigUserPermissionComponent } from './pages/config/config-user-permissions/config-user-permissions.component';
import { adminGuard } from './services/guards/admin.guard';
import { featureGuard } from './services/guards/feature.guard';

const societiesGuard = featureGuard(FeatureFlags.Gesellschaften);
import { ConfigWikiPageComponent } from './pages/config/config-wiki.page/config-wiki.page';
import { ConfigTagsPageComponent } from './pages/config/config-contact-tags.page/config-tags.page';

import { ConfigDashboardPageComponent } from './pages/config/config-dashboard.page/config-dashboard.page';
import { ContactsCompaniesPageComponent } from './pages/contacts/contacts-companies.page/contacts-companies.page';
import { ContactsPersonsPageComponent } from './pages/contacts/contacts-persons.page/contacts-persons.page';
import { ContactsSocietiesPageComponent } from './pages/contacts/contacts-societies.page/contacts-societies.page';
import { ContactsAddSocietyPageComponent } from './pages/contacts/contacts-add-society.page/contacts-add-society.page';
import { ContactsAddCompanyPageComponent } from './pages/contacts/contacts-add-company.page/contacts-add-company.page';
import { ContactsAddPersonPageComponent } from './pages/contacts/contacts-add-person.page/contacts-add-person.page';
import { ContactsCompanyDetailsPageComponent } from './pages/contacts/contacts-company-details.page/contacts-company-details.page';
import { ContactsPersonDetailsComponent } from './pages/contacts/contacts-person-details.page/contacts-person-details.page';
import { GridConnectionListComponent } from './pages/grid-connection-list/grid-connection-list.page';
import { FolderConfigComponent } from './pages/config/folder-config/folder-config.component';
import { TemplateConfigComponent } from './pages/config/template-config/template-config.component';
import { FolderTreeConfigComponent } from './pages/config/folder-config/folder-tree-config/folder-tree-config.component';
import { GridConnectionComponent } from './pages/grid-connection/grid-connection.page';
import { BrowserUtils } from '@azure/msal-browser';
import { WikiMainComponent } from './pages/wiki/wiki-main/wiki-main.page';
import { WikiEditComponent } from './pages/wiki/wiki-edit/wiki-edit.component';
import { WikiArticleComponent } from './pages/wiki/wiki-article/wiki-article.component';
import { TechnicalComponentsComponent } from './pages/technical-components/technical-components.page';
import { EmailEditorComponent } from './pages/email-template-overview/email-editor/email-editor.component';
import { UserTasklistComponent } from './pages/user-tasklist/user-tasklist.component';
import { ExportConfigComponent } from './pages/config/export-config/export-config.component';
import { ProjectCostOverview } from './pages/ProjectCostOverview/ProjectCostOverview.page';
import { GridConnectionOverviewComponent } from './pages/grid-connection/grid-connection-overview/grid-connection-overview.component';
import { GridConnectionPropertiesComponent } from './pages/grid-connection/grid-connection-properties/grid-connection-properties.component';
import { GridConnectionComponentsPage } from './pages/grid-connection/grid-connection-components/grid-connection-components.page';
import { ProjectComponentsComponent } from './pages/grid-connection/project/project-tabs/project-info/project-info-components/project-info-components.component';
import { ProjectCalendarComponent } from './pages/grid-connection/project/project-tabs/project-calendar/project-calendar.component';
import { ProjectContactsComponent } from './pages/grid-connection/project/project-tabs/project-contacts/project-contacts.component';
import { ProjectBaukostenPageComponent } from './pages/grid-connection/project/project-tabs/project-baukosten.page/project-baukosten.page';
import { ProjectCostsPageComponent } from './pages/grid-connection/project/project-tabs/project-costs/project-costs.page';
import { ProjectPage } from './pages/grid-connection/project/project.page';
import { ProjectInfoComponent } from './pages/grid-connection/project/project-tabs/project-info/project-info.component';
import { ProjectInfoOverviewComponent } from './pages/grid-connection/project/project-tabs/project-info/project-info-overview/project-info-overview.component';
import { ProjectInfoMastrComponent } from './pages/grid-connection/project/project-tabs/project-info/project-info-mastr/project-info-mastr.component';
import { ProjectTasksComponent } from './pages/grid-connection/project/project-tabs/project-tasks/project-tasks.component';
import { ProjectDocumentsComponent } from './pages/grid-connection/project/project-tabs/project-documents/project-documents.component';
import { ProjectSandboxComponent } from './pages/grid-connection/project/project-tabs/project-sandbox/project-sandbox.component';
import { ProjectCommentsComponent } from './pages/grid-connection/project/project-tabs/project-comments/project-comments.component';
import { ProjectGalleryPage } from './pages/grid-connection/project/project-tabs/project-gallery/project-gallery.page';
import { ProjectMicroTasksPage } from './pages/grid-connection/project/project-tabs/project-microtasks/project-microtasks.page';
import { WikiComponent } from './pages/wiki/wiki.component';
import { CostsTemplatesComponent } from './pages/templates/templates-project-costs/templates-costs-templates.component';
import { ProjectCostsBudgetPageComponent } from './pages/grid-connection/project/project-tabs/project-costs/project-costs-budget/project-costs-budget.page';
import { ProjectCostsActualPageComponent } from './pages/grid-connection/project/project-tabs/project-costs/project-costs-actual/project-costs-actual.page';
import { ProjectCostsControllingPageComponent } from './pages/grid-connection/project/project-tabs/project-costs/project-costs-controlling/project-costs-controlling.page';
import { DynamicTablesPage } from './pages/dynamic-tables/dynamic-tables.component';
import { DynamicTableViewPage } from './pages/dynamic-tables/dt-view/dt-view.component';
import { DynamicTableEditPage } from './pages/dynamic-tables/dt-edit/dt-edit.component';
import { ConfigTrafficLightPageComponent } from './pages/config/config-traffic-light.page/config-traffic-light.page';
import { EmailReportConfigComponent } from './pages/config/email-report-config/email-report-config.component';
import { AppGlobals } from './app.globals'; // Import AppGlobals
import { FeatureFlags } from './interfaces/enums/feature-flag';
import { ConfigCostCategoriesPage } from './pages/config/config-cost-categories.page/config-cost-categories';
import { DatabaseExportComponent } from './pages/config/database-export/database-export.component';
import { ConfigContractsPageComponent } from './pages/config/config-contracts.page/config-contracts.page.component';
import { ConfigSocietySalesModelsPageComponent } from './pages/config/config-society-sales-models.page/config-society-sales-models.page';
import { ContractsConfigComponent } from './pages/config/contracts-config/contracts-config.component';
import { ContractReviewSettingsComponent } from './pages/config/contracts-config/review-settings/contract-review-settings.component';
import { ContractTemplateSettingsComponent } from './pages/config/contracts-config/template-settings/contract-template-settings.component';
import { ConfigSparkTagsPageComponent } from './pages/config/config-spark-tags.page/config-spark-tags.page';
import { ConfigTagsComponent } from './pages/config/config-tags/config-tags.component';
import { ConfigTaskTagsPageComponent } from './pages/config/config-tags/config-task-tags/config-task-tags.page';
import { SiteContractsComponent } from './pages/grid-connection/site-contracts/site-contracts.component';
import { hasChangesGuard } from './services/guards/unsaved-changes.guard';
import { ProjectHubComponent } from './pages/grid-connection/project/project-tabs/project-hub/project-hub.component';
import { ProjectHubBoardComponent } from './pages/grid-connection/project/project-tabs/project-hub/project-hub-board/project-hub-board.component';
import { GeneralConfigComponent } from './pages/config/general-config.page/general-config.page';
import { GeneralComponent } from './pages/config/general-config.page/general/general.page';
import { UserAdministrationComponent } from './pages/config/general-config.page/user-administration/user-administration.page';
import { ConfigPropertyComponent } from './pages/config/config-property/config-property.component';
import { ProjectConfigComponent } from './pages/config/project-config/project-config.component';
import { ProjectStructureConfigComponent } from './pages/config/project-config/project-structure-config/project-structure-config.component';
import { ProjectTaskConfigComponent } from './pages/config/project-config/project-structure-config/project-task-config/project-task-config.component';
import { ConfigProjectTimelineComponent } from './pages/config/project-config/config-project-timeline/config-project-timeline.component';
import { ConfigScheduleComponent } from './pages/config/project-config/config-schedule/config-schedule.component';
import { ProjectScheduleComponent } from './pages/grid-connection/project/project-tabs/project-schedule/project-schedule.component';
import { ProjectCreationFormComponent } from './pages/grid-connection/project/project-creation-form/project-creation-form.component';
import { ReasonConfigComponent } from './pages/config/project-config/reason-config/reason-config.component';
import { OverviewTaskConfigComponent } from './pages/config/project-config/overview-task-config/overview-task-config.component';
import { ConfigProjectParamsPageComponent } from './pages/config/project-config/config-project-params/config-project-params.page';
import { ConfigTechincalComponentsComponent } from "./pages/config/config-technical-components/config-techincal-components.page/config-technical-components.page";
import { SharepointConfigComponent } from './pages/config/sharepoint-config/sharepoint-config.component';

export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',
  anchorScrolling: 'enabled',

  // Don't perform initial navigation in iframes or popups
  initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled', // Set to enabledBlocking to use Angular Universal
};

const routes: Routes = [
  {
    path: '',
    redirectTo: AppGlobals.UserCan(FeatureFlags.Dashboard) ? 'dashboard' : 'projects',
    pathMatch: 'full',
  },
  { path: 'landing', component: LandingPage },
  { path: 'landing:token', component: LandingPage },
  {
    path: 'landing',
    loadComponent: () => import('./pages/project-list/project-list.page').then(m => m.ProjectListPage),
    data: { menuId: 'projects' },
  },
  {
    path: 'projects',
    loadComponent: () => import('./pages/project-list/project-list.page').then(m => m.ProjectListPage),
    data: { menuId: 'projects' },
  },
  {
    path: 'search',
    loadComponent: () => import('./pages/search-results/search-results.page').then(m => m.SearchResultsPage),
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/project-pipeline/project-pipeline.component').then(m => m.ProjectPipelineComponent),
    data: { menuId: 'project-pipeline' },
  },
  {
    path: 'feedback',
    loadComponent: () => import('./pages/feedback-center/feedback-center.component').then(m => m.FeedbackCenterComponent),
    data: { menuId: 'feedback' },
  },
  {
    path: 'notification-settings',
    loadComponent: () =>
      import('./pages/notification-settings/notification-settings.page').then(m => m.NotificationSettingsPage),
    data: { menuId: 'notification-settings' },
  },
  {
    path: 'contracts',
    data: { menuId: 'contracts' },
    loadComponent: () => import('./pages/contracts/contracts.page').then(m => m.ContractsPageComponent),
    children: [
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full',
      },
      {
        path: 'overview',
        loadComponent: () =>
          import('./pages/contracts/contract-overview/contract-overview.component').then(
            m => m.ContractOverviewComponent
          ),
      },
      {
        path: 'deadlines',
        loadComponent: () =>
          import('./pages/contracts/contract-deadlines/contract-deadlines.component').then(
            m => m.ContractDeadlinesComponent
          ),
      },
      {
        path: 'calendar',
        loadComponent: () =>
          import('./pages/contracts/contract-calendar/contract-calendar.component').then(
            m => m.ContractCalendarComponent
          ),
      },
      {
        path: 'edit/:id',
        loadComponent: () =>
          import('./pages/contracts/contract-detail/contract-detail.component').then(m => m.ContractDetailComponent),
        children: [
          {
            path: '',
            redirectTo: 'overview',
            pathMatch: 'full',
          },
          {
            path: 'overview',
            loadComponent: () =>
              import('./pages/contracts/contract-form/contract-form.component').then(m => m.ContractFormComponent),
            canDeactivate: [hasChangesGuard],
          },
          {
            // Graceful fallback when the AI review tab is navigated to without a review id
            // (e.g. after the embedded review is deleted/re-run): fall back to the overview.
            path: 'ai-review',
            redirectTo: 'overview',
            pathMatch: 'full',
          },
          {
            path: 'ai-review/:id',
            // Embedded under the contract-detail tab wrapper: the contract owns the open/cancel/delete
            // actions, so this flag hides those buttons here (they stay on the standalone list detail).
            data: { embedded: true },
            loadComponent: () =>
              import('./pages/contracts/ai-review/ai-review-details/ai-review-details.component').then(
                m => m.AiReviewDetailsComponent
              ),
          },
        ],
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./pages/contracts/contract-form/contract-form.component').then(m => m.ContractFormComponent),
        canDeactivate: [hasChangesGuard],
      },
      {
        path: 'addToSite/:siteId',
        loadComponent: () =>
          import('./pages/contracts/contract-form/contract-form.component').then(m => m.ContractFormComponent),
        canDeactivate: [hasChangesGuard],
      },
      {
        path: 'addToPropertyOwner/:propertyOwnerId',
        loadComponent: () =>
          import('./pages/contracts/contract-form/contract-form.component').then(m => m.ContractFormComponent),
        canDeactivate: [hasChangesGuard],
      },
      {
        path: 'addToTask/:taskId',
        loadComponent: () =>
          import('./pages/contracts/contract-form/contract-form.component').then(m => m.ContractFormComponent),
        canDeactivate: [hasChangesGuard],
      },
      {
        path: 'document/:docId',
        loadComponent: () =>
          import('./pages/contracts/contract-file-viewer/contract-file-viewer.component').then(
            m => m.ContractFileViewerComponent
          ),
        data: { docId: '', docName: '' },
      },
      {
        path: 'ai-review',
        loadComponent: () => import('./pages/contracts/ai-review/ai-review.page').then(m => m.AiReviewPageComponent),
      },
      {
        path: 'ai-review/:id',
        loadComponent: () => import('./pages/contracts/ai-review/ai-review-details/ai-review-details.component').then(m => m.AiReviewDetailsComponent),
      },
    ],
  },
  {
    path: 'tables',
    component: DynamicTablesPage,
    data: { menuId: 'dynamic-tables' },
    children: [
      { path: ':id/edit', component: DynamicTableEditPage },
      { path: ':id', component: DynamicTableViewPage },
      { path: '', component: DynamicTableViewPage },
    ],
  },

  {
    path: 'project-pipeline',
    loadComponent: () =>
      import('./pages/project-pipeline/project-pipeline.component').then(m => m.ProjectPipelineComponent),
    data: { menuId: 'project-pipeline' },
  },
  {
    path: 'planning-costs',
    loadComponent: () =>
      import('./pages/planning-costs/planning-costs.page').then(m => m.PlanningCostsPage),
    data: { menuId: 'project-pipeline' },
  },
  {
    path: 'contacts',
    component: ContactsComponent,
    data: { menuId: 'contacts' },
    children: [
      { path: 'companies', component: ContactsCompaniesPageComponent },
      {
        path: 'company/:id',
        component: ContactsCompanyDetailsPageComponent,
        canDeactivate: [hasChangesGuard],
      },
      { path: 'addCompany', component: ContactsAddCompanyPageComponent, canDeactivate: [hasChangesGuard] },
      { path: 'persons', component: ContactsPersonsPageComponent },
      {
        path: 'person/:id',
        component: ContactsPersonDetailsComponent,
        canDeactivate: [hasChangesGuard],
      },
      { path: 'addPerson', component: ContactsAddPersonPageComponent, canDeactivate: [hasChangesGuard] },
      { path: 'societies', component: ContactsSocietiesPageComponent, canActivate: [societiesGuard] },
      {
        path: 'addSociety',
        component: ContactsAddSocietyPageComponent,
        canActivate: [societiesGuard],
        canDeactivate: [hasChangesGuard],
      },
      {
        path: 'society/:id',
        component: ContactsAddSocietyPageComponent,
        canActivate: [societiesGuard],
        canDeactivate: [hasChangesGuard],
      },
    ],
  },
  {
    path: 'tech-components',
    component: TechnicalComponentsComponent,
    data: { menuId: 'tech-components' },
  },
  {
    path: 'grid-connections',
    component: GridConnectionListComponent,
    data: { menuId: 'sites' },
  },
  {
    path: 'site/:id',
    component: GridConnectionComponent,
    data: { menuId: 'sites' },
    children: [
      { path: '', redirectTo: 'site-overview', pathMatch: 'full' },
      {
        path: 'site-overview',
        component: GridConnectionOverviewComponent,
        data: { currentSelectedProjectId: '' },
      },
      {
        path: 'create-project',
        component: ProjectCreationFormComponent,
      },
      {
        path: 'project/:id',
        component: ProjectPage,
        children: [
          { path: '', redirectTo: 'projectInfo/overview', pathMatch: 'full' },
          {
            path: 'projectInfo',
            component: ProjectInfoComponent,
            children: [
              { path: '', redirectTo: 'overview', pathMatch: 'full' },
              { path: 'overview', component: ProjectInfoOverviewComponent },
              { path: 'headdata', redirectTo: 'overview', pathMatch: 'full' },
              { path: 'mastr', component: ProjectInfoMastrComponent },
              { path: 'components', component: ProjectComponentsComponent },
              { path: 'schedule', component: ProjectScheduleComponent },
            ],
          },
          { path: 'tasks', component: ProjectTasksComponent },
          { path: 'tasks/:taskId', component: ProjectTasksComponent },
          { path: 'documents', component: ProjectDocumentsComponent },
          { path: 'sandbox', component: ProjectSandboxComponent },
          // { path: 'comments', component: ProjectCommentsComponent },
          {
            path: 'project-hub',
            component: ProjectHubComponent,
            children: [
              { path: '', component: ProjectHubBoardComponent },
              { path: ':boardId', component: ProjectHubBoardComponent },
              { path: '**', redirectTo: '' },
            ],
          },
          { path: 'calendar', component: ProjectCalendarComponent },
          { path: 'gallery', component: ProjectGalleryPage },
          { path: 'microtasks', component: ProjectMicroTasksPage },
          { path: 'project-contacts', component: ProjectContactsComponent },

          {
            path: 'project-costs',
            component: ProjectCostsPageComponent,
            children: [
              { path: '', redirectTo: 'actual', pathMatch: 'full' },
              { path: 'budget', component: ProjectCostsBudgetPageComponent },
              { path: 'actual', component: ProjectCostsActualPageComponent },
              {
                path: 'controlling',
                component: ProjectCostsControllingPageComponent,
              },
            ],
          },
        ],
      },

      { path: 'properties', component: GridConnectionPropertiesComponent },
      { path: 'infrastructure', component: GridConnectionComponentsPage },
      {
        path: 'site-contracts',
        component: SiteContractsComponent,
        children: [
          { path: '', redirectTo: 'overview', pathMatch: 'full' },
          {
            path: 'overview',
            loadComponent: () =>
              import('./pages/contracts/contract-overview/contract-overview.component').then(
                m => m.ContractOverviewComponent
              ),
          },
          {
            path: 'deadlines',
            loadComponent: () =>
              import('./pages/contracts/contract-deadlines/contract-deadlines.component').then(
                m => m.ContractDeadlinesComponent
              ),
          },
          {
            path: 'calendar',
            loadComponent: () =>
              import('./pages/contracts/contract-calendar/contract-calendar.component').then(
                m => m.ContractCalendarComponent
              ),
          },
        ],
      },
    ],
  },

  {
    path: 'config',
    component: ConfigPageComponent,
    canActivate: [adminGuard],
    data: { menuId: 'admin' },
    children: [
      {
        path: 'general-config',
        component: GeneralConfigComponent,
        children: [
          {
            path: '',
            redirectTo: 'general',
            pathMatch: 'full',
          },
          {
            path: 'general',
            component: GeneralComponent,
          },
          {
            path: 'user-administration',
            component: UserAdministrationComponent,
          },
          {
            path: 'organization',
            loadComponent: () =>
              import('./pages/config/general-config.page/organization/organization.page').then(
                m => m.OrganizationComponent
              ),
          },
        ],
      },
      { path: 'wiki', component: ConfigWikiPageComponent },
      { path: 'dashboard', component: ConfigDashboardPageComponent },
      // Contact / Spark / Task tags live as tabs of one Admin ▸ Tags page (#797, #4808)
      {
        path: 'tags',
        component: ConfigTagsComponent,
        children: [
          { path: '', redirectTo: 'tasks', pathMatch: 'full' },
          { path: 'tasks', component: ConfigTaskTagsPageComponent },
          { path: 'contacts', component: ConfigTagsPageComponent },
          { path: 'spark', component: ConfigSparkTagsPageComponent },
        ],
      },
      { path: 'contact-tags', redirectTo: 'tags/contacts', pathMatch: 'full' },
      {
        path: 'project-config',
        component: ProjectConfigComponent,
        children: [
          { path: '', component: ConfigProjectTimelineComponent },
          {
            path: 'configuration',
            children: [
              { path: '', component: ProjectStructureConfigComponent },
              {
                path: 'tasks',
                component: ProjectTaskConfigComponent,
              },
            ],
          },
          {
            path: 'project-parameters',
            component: ConfigProjectParamsPageComponent,
          },
          { path: 'project-schedule', component: ConfigScheduleComponent },
          { path: 'reasons', component: ReasonConfigComponent },
          { path: 'overview-tasks', component: OverviewTaskConfigComponent },
        ],
      },
      {
        path: 'template-config',
        children: [{ path: '', component: TemplateConfigComponent }],
      },
      {
        path: 'folder-config',
        component: FolderConfigComponent,
        children: [
          { path: '', redirectTo: 'site', pathMatch: 'full' },
          {
            path: 'site',
            component: FolderTreeConfigComponent,
            data: { treeType: 'site' },
          },
          {
            path: 'project',
            component: FolderTreeConfigComponent,
            data: { treeType: 'project' },
          },
        ],
      },
      {
        path: 'sharepoint-config',
        component: SharepointConfigComponent,
      },
      { path: 'export-config', component: ExportConfigComponent },
      {
        path: 'traffic-light-config',
        component: ConfigTrafficLightPageComponent,
      },
      { path: 'email-report-config', component: EmailReportConfigComponent },
      {
        path: 'contracts-config',
        component: ContractsConfigComponent,
        children: [
          { path: '', redirectTo: 'types', pathMatch: 'full' },
          { path: 'types', component: ConfigContractsPageComponent },
          {
            path: 'review-settings',
            component: ContractReviewSettingsComponent,
          },
          {
            path: 'templates',
            component: ContractTemplateSettingsComponent,
          },
        ],
      },
      { path: 'societies-config', component: ConfigSocietySalesModelsPageComponent, canActivate: [societiesGuard] },
      { path: 'database-export', component: DatabaseExportComponent },
      { path: 'templates-costs-templates', component: CostsTemplatesComponent },
      { path: 'cost-category-config', component: ConfigCostCategoriesPage },
      { path: 'spark-tags', redirectTo: 'tags/spark', pathMatch: 'full' },
      { path: "technical-components-config", component: ConfigTechincalComponentsComponent },
      {
        path: 'user-permissions',
        component: ConfigUserPermissionComponent,
      },

      {
        path: 'property-config',
        component: ConfigPropertyComponent,
      },
      {
        path: 'activity-log',
        loadComponent: () =>
          import('./pages/config/config-activity-log.page/config-activity-log').then(
            m => m.ConfigActivityLogComponent
          ),
      },
    ],
  },
  {
    path: 'projectcost-overview',
    component: ProjectCostOverview,
    data: { menuId: 'projectcost-overview' },
  },
  {
    path: 'wiki',
    component: WikiComponent,
    children: [
      {
        path: 'internal',
        children: [
          { path: '', component: WikiMainComponent },
          { path: ':id/edit', component: WikiEditComponent },
          { path: ':id/:tag', component: WikiArticleComponent },
          { path: ':id', component: WikiArticleComponent },
          { path: '**', redirectTo: '' },
        ],
      },
      {
        path: 'manual',
        loadComponent: () =>
          import('./pages/wiki/wiki-manual/wiki-manual-page/wiki-manual-page.component').then(
            m => m.WikiManualPageComponent
          ),
      },
      { path: '**', redirectTo: 'internal' },
    ],
    data: { menuId: 'wiki' },
  },
  {
    path: 'user-tasklist',
    component: UserTasklistComponent,
    data: { menuId: 'user-tasks' },
  },
  { path: 'email-templates', component: EmailTemplateOverviewComponent },
  { path: 'email-editor', component: EmailEditorComponent },
  { path: 'logout', component: LogoutPage },
  { path: 'login-page', component: AppLoginComponent },

  {
    path: 'file-viewer',
    loadComponent: () => import('./pages/file-viewer/file-viewer.page').then(m => m.FileViewerPage),
  },
  {
    path: 'fill-template-preview',
    loadComponent: () =>
      import('./pages/fill-template-preview/fill-template-preview.page').then(m => m.FillTemplatePreviewPage),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
